import { defineComponent as _defineComponent } from 'vue'
import { __ } from 'bits/intl'
import OzIcon from 'library/v4/components/OzIcon.vue'
import OzListRow from 'library/v4/components/OzListRow.vue'
import OzTextButton, { OzTextButtonColorScheme } from 'library/v4/components/OzTextButton.vue'
import SurfaceDropdownReactionBase from 'vuecomponents/SurfaceDropdownReactionBase.vue'
import { useReactionsStore } from 'pinia/surface_reactions'
import { storeToRefs } from 'pinia'
import { useDarkModeStore } from 'pinia/dark_mode'
import { useSurfaceStore } from 'pinia/surface'
import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SurfaceDropdownReactionStar',
  props: {
    usageContext: null
  },
  setup(__props: any) {

const props = __props as {
  usageContext: 'postView' | 'postExpandedView'
}



const { accumulatedReactionsByWishId, postIdBeingReactedTo, originalReactionData } = storeToRefs(useReactionsStore())
const accumulatedReaction = computed(
  () =>
    accumulatedReactionsByWishId.value[postIdBeingReactedTo.value as number] || {
      sum: 0,
      totalReactionsCount: 0,
    },
)

const myRating = computed(() => accumulatedReaction.value?.userReaction?.value ?? 0)

const isDarkMode = storeToRefs(useDarkModeStore()).isDarkMode
const colorScheme = storeToRefs(useSurfaceStore()).colorScheme
const isPadletColorSchemeDark = computed(() => {
  return props.usageContext === 'postExpandedView' ? isDarkMode.value : colorScheme.value === 'dark'
})
const dir = storeToRefs(useSurfaceStore()).dir

const { createReaction, updateReaction, deleteReaction, stopEditingReaction } = useReactionsStore()

function rate(value): void {
  if (myRating.value > 0) {
    updateReaction({ postId: postIdBeingReactedTo.value, value })
  } else {
    createReaction({ postId: postIdBeingReactedTo.value, value })
  }
  stopEditingReaction()
}

function unrate(): void {
  deleteReaction({ postId: postIdBeingReactedTo.value })
  stopEditingReaction()
}

return { __sfc: true,props, accumulatedReactionsByWishId, postIdBeingReactedTo, originalReactionData, accumulatedReaction, myRating, isDarkMode, colorScheme, isPadletColorSchemeDark, dir, createReaction, updateReaction, deleteReaction, stopEditingReaction, rate, unrate, __, OzIcon, OzListRow, OzTextButton, OzTextButtonColorScheme, SurfaceDropdownReactionBase }
}

})